import { defineFeatures } from "../define-provider-capability";

const mobileDopplerEnv = (name: string) => ({
  name,
  availability: "boot" as const,
  mobileEasArtifact: "eas-json" as const,
  source: {
    kind: "doppler" as const,
    project: "mobile",
    config: "environment" as const,
  },
});

/**
 * The `sentry` features the mobile service selects. The app's bundle
 * carries these through `@libs/environment-client-contracts/mobile`, not the rest of
 * the capability, so a server-only change to it does not change the app.
 */
export const sentryMobileFeatures = defineFeatures({
  // Mobile runtime DSN baked into the mobile bundle.
  mobile: {
    scope: "runtime",
    environments: {
      local: { mode: "managed" },
      preview: { mode: "managed" },
      production: { mode: "managed" },
    },
    env: [mobileDopplerEnv("EXPO_PUBLIC_SENTRY_DSN")],
  },
  // EAS build-time secrets used by @sentry/react-native to upload sourcemaps
  // during the mobile build. Not needed at runtime; only required when the
  // EAS build runs (preview deploy).
  mobileBuild: {
    scope: "runtime",
    environments: {
      local: {
        mode: "not-applicable",
        note: "Local Metro runs do not perform an EAS build.",
      },
      preview: { mode: "managed" },
      production: { mode: "managed" },
    },
    env: [
      mobileDopplerEnv("SENTRY_AUTH_TOKEN"),
      mobileDopplerEnv("SENTRY_ORG"),
      mobileDopplerEnv("SENTRY_PROJECT"),
    ],
  },
});
